import Player from "@/components/LottiePlayer";

export default function MoreFeatures() {

  const features = [
    {
      title: "TECHNICAL ANALYSIS",
      text: "We carry out a technical analysis to identify where you fall on the data management maturity model and appraise your existing systems.",
      icon: "/assets/icons/data-portal.json"
    },
     {
      title: "IDENTIFY YOUR NEEDS",
      text: "You tell us your area of need, your organization's specific objectives, and the data you want to publish, and we work together to define your goals.",
      icon: "/assets/icons/seeding.json"
    },
    {
      title: "REQUIREMENTS ANALYSIS",
      text: "We conduct a thorough analysis of your requirements and identify the necessary features, customizations, and integrations.",
      icon: "/assets/icons/analytical-skill.json"
    },
    {
      title: "RAPID DATA PORTAL SETUP",
      text: "We set up a solution that is ready to go straight out of the box. This takes minutes.",
      icon: "/assets/icons/robot.json"
    },
    {
      title: "DATA INTEGRATION AND MIGRATION",
      text: "We work closely with you to integrate and migrate your data into the open data portal, ensuring that it's properly formatted, cleaned, and organized to meet open data standards.",
      icon: "/assets/icons/repair-tools.json"
    },
    {
      title: "CUSTOMIZATION",
      text: "If needed, we work with you to customize and extend your solution. This can include adding data visualization tools and features such as data versioning, secure data sharing, etc.",
      icon: "/assets/icons/connection.json"
    },
    {
      title: "TESTING, QUALITY ASSURANCE, AND DEPLOYMENT",
      text: "Our team conducts rigorous testing and quality assurance to ensure the open data portal is functioning optimally and meeting your requirements.",
      icon: "/assets/icons/bar-chart-1.json"
    },
    {
      title: "USER TRAINING AND DOCUMENTATION",
      text: "We provide comprehensive training and documentation for your team, ensuring they are well-equipped to manage and maintain the open data portal effectively.",
      icon: "/assets/icons/presentation-4.json"
    },
    {
      title: "ONGOING SUPPORT AND MAINTENANCE",
      text: "We provide ongoing support and maintenance (regular updates, security patches, and troubleshooting) to ensure your portal continues to meet your needs.",
      icon: "/assets/icons/presentation.json"
    },
  ]

  return (
    <section className="my-16 flex flex-col items-center justify-center md:py-12 bg-white bg-center font-['Inter']">
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl container px-8 ">
        <div className="text-center text-maingray" tabIndex={0}>
          <h3 className="mb-8 text-4xl md:text-5xl tracking-tight leading-tight font-bold md:leading-tight">
            How it works
          </h3>
          <p className="body-text mb-16 xl:mb-24 mx-auto  max-w-4xl">
            Experience a perfect blend of professional insights and cutting-edge technology, as our team guides you from in-depth analysis to continuous support. Our expert-driven, step-by-step approach guarantees a customized solution that elevates your organization&apos;s data management to new heights. 
          </p>
        </div>
      </div>
      <div className="xl:max-w-7xl lg:max-w-5xl md:max-w-3xl grid grid-cols-1 lg:grid-cols-3 gap-14 px-4">
        {features.map((feature) => (
            <div key={feature.icon}tabIndex={0} className="p-16 flex flex-col items-center text-center rounded-3xl shadow-lg transition ease-in-out hover:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] ">
              <Player
                autoplay
                loop
                src={feature.icon}
                style={{ height: "80px", width: "80px" }}
              />
              <h3 className="font-['Inter'] text-xl font-bold text-orange-400  py-2"> {feature.title} </h3>
              <p className="body-text"> {feature.text} </p>
            </div>
        ))}
      </div>
    </section>
  );
}